const colors = require('../styles/colors')

module.exports = {
  pathPrefix: '/',
  siteTitle: 'Read My Book Notes',
  siteLongTitle: 'Read My Book Notes',
  siteUrl: 'https://readmybooknotes.com',
  siteLanguage: 'en',
  siteLogo: '/logos/logo-1024.png',
  siteDescription: 'Books Recommendations and Summaries',
  // manifest.json
  manifestName: 'Read My Book Notes',
  manifestShortName: 'Read My Book Notes',
  manifestStartUrl: '/',
  manifestBackgroundColor: colors.first,
  manifestThemeColor: colors.firstLight,
  manifestDisplay: 'standalone',
  // analytics
  analyticsTrackingId: 'UA-111761439-1',
  // author note
  authorName: 'Latish Sehgal',
  authorDescription: `Learner, Code Slinger.`,
  // texts
  copyright: `Copyright © ${new Date().getFullYear()} - Latish Sehgal`
}



// WEBPACK FOOTER //
// ./src/utils/siteConfig.js